import { helpers } 		from './theme/helpers.js';
import { hamburger } 	from './theme/components/hamburger.js';
import { aside } 		from './theme/components/aside.js';
import { search } 		from './theme/components/search.js';

window.theme = {
	globals: {
		isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
		isTabActive: true,
		/* scroll: {
			last: 0,
			min: 300,
			class: 'scrolling-down'
		}, */
	},
	
	init: function () {
		var self = this;

		hamburger.init();
		aside.init();
		search.init();

		// Global
		self.loadFancy();
		self.onloadClass();
		self.touch();
		self.smoothScroll.init();
	},

	loadFancy: function() {
		// jQuery( 'p a[rel="noopener"]' ).has("img").fancybox(); class="fancybox" data-fancybox="gallery"
		jQuery( '.doc-detail article a:has( img )' ).each(function(){
			jQuery(this).attr( 'data-fancybox', 'gallery' );
		});
	},

	onloadClass: function () {
		document.querySelector('body').classList.add('loaded');
	},

	touch: function () {
		var self = this;

		var touchClass = self.globals.isTouch === true ? 'touch-device' : 'pointer-device';
		document.querySelector('body').classList.add( touchClass );
	},

	smoothScroll: {
		selector: 'a[href*="#"]:not([href="#"])',
		init: function () {
			var self = this;

			var scroll = new SmoothScroll(self.selector, {
				ignore: '[data-scroll-ignore]',
				topOnEmptyHash: false,
				speed: 1000,
				offset: function (anchor, toggle) {
					var headerOffset = 0;

					/* if( jQuery( anchor ).offset().top < jQuery( window ).scrollTop() + headerOffset ) {
						headerOffset = jQuery( '.header.header--p-fixed' ).css( '--header-height' )
						headerOffset = headerOffset.replace( 'px', '');
					}

					if( !headerOffset ) {
						headerOffset = 0;
					} */
	
					return headerOffset;
				},
				updateURL: false,
				easing: 'easeInOutCubic',
			});
		},
	},

	windowPosition: function () {
		return {
			x: window.pageXOffset || document.documentElement.scrollLeft,
			y: window.pageYOffset || document.documentElement.scrollTop,
		};
	},

	windowSizes: function () {
		return {
			width: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
			height: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
		};
	},

	onresize() {
		var self = this;

	},

	onscroll() {
		var self = this;

		/* const currentScroll = window.pageYOffset;

		if ( currentScroll > self.globals.scroll.last && currentScroll > self.globals.scroll.min ) {
			document.body.classList.add( self.globals.scroll.class );
		} else if ( currentScroll < self.globals.scroll.last ) {
			document.body.classList.remove( self.globals.scroll.class );
		}

		self.globals.scroll.last = currentScroll; */
	},
};

jQuery(function() {
	theme.init();
});

window.addEventListener('scroll', function (e) {
	theme.onscroll();  	
});

window.addEventListener('resize', function (e) {
	theme.onresize();
});

window.onfocus = function () { 
	theme.globals.isTabActive = true; 
}; 

window.onblur = function () { 
	theme.globals.isTabActive = false; 
};
